// extracted by mini-css-extract-plugin
module.exports = {"dealing":"UserServices_dealing__39qyU","types":"UserServices_types__2CC4s","title":"UserServices_title__33cEZ","disabledTab":"UserServices_disabledTab__2UFB1"};